import { render } from "./CobrancaParcelaStatusSelect.vue?vue&type=template&id=b50daa74"
import script from "./CobrancaParcelaStatusSelect.vue?vue&type=script&lang=js"
export * from "./CobrancaParcelaStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__